export default __webpack_public_path__ + "static/media/card-project1.3edc25ac.png";